import {useLogOutMutation} from "@src/features/auth/redux/auth-api";
import {selectIsLoggedIn, selectUserFullInfo} from "@src/features/auth/redux/auth-slice";
import {useAppSelector} from "@src/integrations/redux/redux-store";
import {Avatar, AvatarFallback, AvatarImage} from "@src/ui/views/avatar";
import {Button} from "@src/ui/views/button";
import {
	DropdownMenu,
	DropdownMenuContent,
	DropdownMenuItem,
	DropdownMenuLabel,
	DropdownMenuSeparator,
	DropdownMenuTrigger
} from "@src/ui/views/dropdown-menu";
import {CircleUser} from "lucide-react";
import * as React from "react";
import {NavLink} from "react-router-dom";


export function AccountMenu() {
	const [triggerLogOut, logOutState] = useLogOutMutation();
	const userFullInfo = useAppSelector(selectUserFullInfo)!;
	
	const onLogOutClicked = React.useCallback(() => {
		triggerLogOut();
	}, [triggerLogOut]);
	
	return (
		<DropdownMenu>
			<DropdownMenuTrigger asChild>
				<Button
					variant="ghost"
					size="icon"
					className="rounded-full overflow-clip outline outline-2 outline-transparent hover:outline-blue-600 radix-state-open:outline-blue-500"
				>
					<Avatar>
						{
							userFullInfo.profilePic && (
								<AvatarImage
									src={userFullInfo.profilePic}
									alt={`${userFullInfo.firstName} ${userFullInfo.lastName}`}
								/>
							)
						}
						<AvatarFallback>
							<CircleUser/>
						</AvatarFallback>
					</Avatar>
					<span className="sr-only">Toggle user menu</span>
				</Button>
			</DropdownMenuTrigger>
			<DropdownMenuContent align="end">
				<DropdownMenuLabel>My Account</DropdownMenuLabel>
				<DropdownMenuSeparator/>
				<DropdownMenuItem>
					<NavLink to={"/dashboard"}>
						Choose Dashboard
					</NavLink>
				</DropdownMenuItem>
				<DropdownMenuItem>
					<NavLink to={`/dashboard/settings`}>
						Settings
					</NavLink>
				</DropdownMenuItem>
				<DropdownMenuItem>
					<NavLink to={`/dashboard/contact`}>
						Support
					</NavLink>
				</DropdownMenuItem>
				<DropdownMenuSeparator/>
				<DropdownMenuItem
					onClick={onLogOutClicked}
					disabled={logOutState.isLoading}
				>
					Logout
				</DropdownMenuItem>
			</DropdownMenuContent>
		</DropdownMenu>
	);
}


export function OptionalAccountMenu() {
	const isLoggedIn = useAppSelector(selectIsLoggedIn);
	
	if (!isLoggedIn) {
		return null;
	}
	
	return (
		<AccountMenu/>
	);
}
